export class Warning {
  title: string
  message: string
  onClose?: (() => void) | undefined

  constructor (title: string, message: string, onClose?: () => void) {
    this.title = title
    this.message = message
    this.onClose = onClose
  }
}
